<header class="auth-header">
  <a
    routerLink="/login"
    class="auth-header__brand"
    [attr.aria-label]="brandProfile.productName + ' - Inicio'"
  >
    <img [src]="brandProfile.logoPath" alt="" class="auth-header__logo" />
    <div class="auth-header__titles">
      <span class="auth-header__name">{{ brandProfile.productName }}</span>
      <span class="auth-header__tagline">Acceso de clientes</span>
    </div>
  </a>

  @if (cta(); as headerCta) {
    <a [routerLink]="headerCta.link" class="auth-header__cta">{{ headerCta.label }}</a>
  }
</header>
